export const updateSession = async (sessionId: string, status: string) => {
    try {
        const response = await fetch(
            `https://api.reclaimprotocol.org/api/sdk/update/session/`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId,
                    status: status,
                }),
            }
        );

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            console.error("Request to update Session Status failed with status:", response.status);
        }
    } catch (error) {
        console.error("Error:", error);
    }
    return undefined;
};
